import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import StarfieldCanvas from './StarfieldCanvas';
import QuickActions from './QuickActions';
import NotificationPanel from './NotificationPanel';
import EnforceaBlogPanel from './EnforceaBlogPanel';
import RegulationFeed from './RegulationFeed';

gsap.registerPlugin(ScrollTrigger);

export default function MainDashboard() {
  const gridRef = useRef(null);
  const widgetsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      widgetsRef.current.forEach((widget, i) => {
        if (!widget) return;
        gsap.fromTo(widget,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            delay: i * 0.07,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: widget,
              start: 'top 85%',
              toggleActions: 'play none none none',
            },
          }
        );
      });
    }, gridRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="min-h-screen bg-paper text-text-pri font-sans selection:bg-brand selection:text-white relative overflow-x-hidden">
      {/* ── INTERACTIVE ANIMATED STARFIELD ── */}
      <StarfieldCanvas />

      {/* ── DASHBOARD CONTENT ── */}
      <section
        ref={gridRef}
        className="relative py-8 px-6 sm:px-10 z-10"
      >
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
            {/* Left Column — Heading + Feature cards */}
            <div className="xl:col-span-8 space-y-2">
              <div ref={(el) => { widgetsRef.current[0] = el; }}>
                <QuickActions />
              </div>
            </div>

            {/* Right Column — News & EnforceA Articles */}
            <div className="xl:col-span-4 space-y-6">
              <div ref={(el) => { widgetsRef.current[1] = el; }}>
                <NotificationPanel />
              </div>
              <div ref={(el) => { widgetsRef.current[2] = el; }}>
                <EnforceaBlogPanel />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
